import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import MatchList from "../MatchList/MatchList";
import AddMatchBar from "./AddMatchBar";
import IsOfficialSwitch from "./IsOfficialSwitch";
import "../styles/MatchDaysList.css";
import DateComponent from "./DateComponent";
import { useTranslation } from "react-i18next";

export default function MatchDayForm({}) {
    const { t } = useTranslation();
    return (
        <Accordion defaultExpanded elevation={5}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography>{t("gamedays.add_matchday.title")}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div className="matchdays-block-header">
                    <DateComponent matches={[]} />
                    <IsOfficialSwitch disabled />
                </div>
                <MatchList matches={[]} withForm={true} />
                <AddMatchBar isNew={true} />
                {/* You should add match in order to register new matchDay. */}
                <div className="add-new-warning">
                    {t("gamedays.add_matchday.add_match_required_message")}
                </div>
            </AccordionDetails>
        </Accordion>
    );
}
